<div class="loading">
  <img class="light-loader" src="assets/gif/Light-loader-200px.gif" alt="light-loader">
  <img class="dark-loader" src="assets/gif/Dark-loader-200px.gif" alt="dark-loader">
</div>